export class GobalInputValidationEvent extends Event {


  constructor() {
    super("GobalInputValidationEvent");

  }
}